import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import websitePage, { footerTypes, headerTypes } from 'hoc/websitePage/websitePage';
import { NU_CONTA } from 'utils/prospectTypes';
import QuickNavigation from 'components/QuickNavigation/QuickNavigation';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionBenefits from './patterns/SectionBenefits/SectionBenefits';
import SectionDebit from './patterns/SectionDebit/SectionDebit';
import SectionCalculator from './patterns/SectionCalculator/SectionCalculator';
import SectionPayments from './patterns/SectionPayments/SectionPayments';
import SectionLockedDeposits from './patterns/SectionLockedDeposits/SectionLockedDeposits';
import SectionFees from './patterns/SectionFees/SectionFees';
import SectionSecurity from './patterns/SectionSecurity/SectionSecurity';
import SectionContact from './patterns/SectionContact/SectionContact';
import SectionFAQ from './patterns/SectionFAQ/SectionFAQ';
import SectionCrossSell from './patterns/SectionCrossSell/SectionCrossSell';
import tracking from './tracking';

function Account({ isAnchorAllowed }) {
  const { formatMessage } = useContext(NuDsContext);
  const accountCardsArea = formatMessage({ id: 'cms.accountPage.cardsArea' });

  const accountCardsMap = {
    SectionBenefits,
    SectionPayments,
    SectionDebit,
    SectionCalculator,
    SectionLockedDeposits,
    SectionFees,
    SectionSecurity,
    SectionContact,
    SectionFAQ,
    SectionCrossSell,
  };

  return (
    <QuickNavigation
      isAnchorAllowed={isAnchorAllowed}
      onClick={label => { tracking.quickNavigation(label); }}
    >
      <QuickNavigation.Item
        id={formatMessage({ id: 'cms.accountPage.heroQuicknavId' })}
        intlKey="cms.accountPage.heroQuicknavTitle"
      >
        <SectionForm />
      </QuickNavigation.Item>
      {accountCardsArea && accountCardsArea.map((cardItem, index) => {
        const CardComponent = accountCardsMap[cardItem.componentName];
        const quickNavigationId = formatMessage({ id: `cms.accountPage.cardsArea[${index}].quicknavId`, optional: true });
        const key = `accountCardsArea__${index}`;

        if (!CardComponent) return null;

        if (!quickNavigationId) return <CardComponent key={key} index={index} />;

        return (
          <QuickNavigation.Item
            key={key}
            id={quickNavigationId}
            intlKey={`cms.accountPage.cardsArea[${index}].quicknavTitle`}
          >
            <CardComponent index={index} />
          </QuickNavigation.Item>
        );
      })}
    </QuickNavigation>
  );
}

Account.propTypes = {
  isAnchorAllowed: PropTypes.bool.isRequired,
};

export default websitePage({
  routeKey: 'ACCOUNT',
  widgetProspectType: NU_CONTA,
  header: headerTypes.PRODUCT_PAGE,
  footer: footerTypes.FULL,
})(Account);
